
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.container {
  position:relative;
  height:100%;
  font-family:ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.heart-health {
  margin-right:10px;
}

.menu-wrapper {
  z-index:20;
  min-width:12rem;
  max-width:20.3125rem;
  width:100vw;
  border-top:4px solid var(--bh-brand-primary-default);
}

.menu-wrapper.hidden{
    display:none;
  }

.menu-wrapper.open {
  display:block;
}

.accordion-menu {
  position:relative;
  margin-left:auto;
  margin-right:auto;
  max-height:0px;
  width:100%;
  overflow:hidden;
}

.accordion-menu.open {
  overflow:visible;
  max-height:62.5rem;
  max-height:calc-size(max-content, size);
}
`;